export const environment = {
    production: false,
    //LHP apiBaseUrl: 'https://nodebetestwindows.azurewebsites.net/api/v1/',
    apiBaseUrl: 'https://web-ui-backend.azurewebsites.net/api/v1/',

    //apiBaseUrl: 'http://localhost:8080/api/v1/',
    authToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpYXQiOjE2ODU3Mzg2NDZ9.Mzku8ODlRCdDIPOU83SoDuIej3MPqjQX2IIxaR_1ANs'
};

//This has a CI/CD Pipeline, just push to main

//URL: https://victorious-island-0e5a7cf03.4.azurestaticapps.net

//User: felice.ferri@lhpes.com
//Pwd: 3LxcY9fPn
